import { Component, OnInit } from '@angular/core';
import { NbWindowRef } from '@nebular/theme';

@Component({
    selector: 'app-team-players-modal',
    templateUrl: './team-players-modal.component.html',
    styleUrls: ['./team-players-modal.component.scss'],
})
export class TeamPlayersModalComponent implements OnInit {
    registers: any;
    statusCode: number;
    participantes: any[] = [];

    constructor(protected nbWindowRef: NbWindowRef) {}

    ngOnInit(): void {
        const { equipe, ...game }: any = this.nbWindowRef.config.context;

        this.participantes = equipe || [];
    }
}
